import { css } from "./SKT";

export const SKTButton = ({ onClick, label, type, disabled }) => {
  const btnClass = type ?? "btn-success";
  const preventDefault = (event) => {
    event.preventDefault();
    onClick();
    return false;
  };
  return (
    <button
      style={{ margin: 10 }}
      className={css("btn " + btnClass)}
      onClick={preventDefault}
      disabled={disabled}
    >
      {label}
    </button>
  );
};
